/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetTuyaDevicesPathParameters } from 'api/actions/get-tuya-devices/get-tuya-devices-path-parameters';
import { GetTuyaDevicesResponse } from 'api/actions/get-tuya-devices/get-tuya-devices-response';

type GetTuyaDevicesQueryParameters = Record<string, any>;

/**
 * The path of the GetTuyaDevices action.
 */
export const getTuyaDevicesActionPath = new SweetPath<keyof GetTuyaDevicesPathParameters>('/tuya-devices', {
  path: '{param}',
});

/**
 * Creates a contextualized GetTuyaDevices actions.
 */
export default function createGetTuyaDevicesAction(axios: AxiosInstance) {
  return function getTuyaDevicesAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetTuyaDevicesQueryParameters } = {}) {
    const path = getTuyaDevicesActionPath.original;

    return axios.get<GetTuyaDevicesResponse, GetTuyaDevicesResponse>(path, { params: query, headers });
  };
}
